// for user registration
export const USER_DETAILS = "user_details";
export const USER_DETAILS_SUCCESS = "user_details_success";
export const USER_DETAILS_FAILURE = "user_details_failure";
